import { render, staticRenderFns } from "./bookShelf.vue?vue&type=template&id=9081e5ca&scoped=true&"
import script from "./bookShelf.vue?vue&type=script&lang=js&"
export * from "./bookShelf.vue?vue&type=script&lang=js&"
import style0 from "./bookShelf.vue?vue&type=style&index=0&id=9081e5ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9081e5ca",
  null
  
)

export default component.exports